import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { X } from 'lucide-react';

// Modal central — DESIGN-SYSTEM.md §5.6 "Center modal" (mesmo padrão real já
// usado por `pages/services/View.js`: scrim + box 20px + header
// ícone-badge/título/descrição + X + corpo rolável + rodapé com ações à
// direita). Reaproveitado por Abrir caixa / Sangria / Integração / Excluir —
// item "Lista de caixas" do FRONTEND-TASKS.md, que pede exatamente
// "mesmo modal central usado para Excluir/Integração" para essas ações.
export default function CenterModal({
    open,
    onClose,
    icon: Icon,
    iconBg,
    iconColor,
    title,
    description,
    children,
    onConfirm,
    confirmText = 'Salvar',
    confirmColor,
    loading = false,
    maxWidth = 'sm',
}) {
    return (
        <Dialog
            open={open}
            onClose={loading ? undefined : onClose}
            fullWidth
            maxWidth={maxWidth}
            PaperProps={{ sx: { borderRadius: '20px', overflow: 'hidden' } }}
        >
            <Box sx={{
                px: '22px',
                pt: '20px',
                pb: '14px',
                borderBottom: '1px solid',
                borderColor: 'divider',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: 1.25,
            }}>
                <Box sx={{ minWidth: 0 }}>
                    {Icon && (
                        <Box sx={{
                            width: 38,
                            height: 38,
                            borderRadius: '11px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: iconBg || 'info.bg',
                            color: iconColor || 'primary.main',
                            mb: '10px',
                        }}>
                            <Icon size={18} strokeWidth={2} />
                        </Box>
                    )}
                    <Typography sx={{ fontSize: '17px', fontWeight: 800, mb: '4px' }}>
                        {title}
                    </Typography>
                    {description && (
                        <Typography sx={{ fontSize: '12.5px', color: 'text.secondary' }}>
                            {description}
                        </Typography>
                    )}
                </Box>
                <IconButton onClick={onClose} size="small" disabled={loading} aria-label="Fechar">
                    <X size={15} strokeWidth={2} />
                </IconButton>
            </Box>

            <Box sx={{ p: '18px 22px', maxHeight: '65vh', overflowY: 'auto' }}>
                {children}
            </Box>

            <Box sx={{
                p: '16px 22px 20px',
                borderTop: '1px solid',
                borderColor: 'divider',
                display: 'flex',
                gap: 1.25,
                justifyContent: 'flex-end',
            }}>
                <Button variant="outlined" onClick={onClose} disabled={loading}>Cancelar</Button>
                {onConfirm && (
                    <Button
                        variant="contained"
                        onClick={onConfirm}
                        disabled={loading}
                        color={confirmColor}
                        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
                    >
                        {loading ? 'Salvando...' : confirmText}
                    </Button>
                )}
            </Box>
        </Dialog>
    );
}
